<template>
  <div
    ref="container"
    :class="{ scrolling: isDown, snap, 'scroll-min': scrollbar === 'minimal', 'scroll-none': (scrollbar = 'none') }"
    class="drag-scroll"
  >
    <slot></slot>
  </div>
</template>
<script>
import { ref } from 'vue';
import useEventListener from '@/compositions/useEventListener.js';

export default {
  props: {
    snap: {
      type: Boolean,
      default: false,
    },
    scrollbar: {
      type: String,
      default: 'minimal',
    },
  },

  setup() {
    const CLICK_PREVENT_THRESHOLD = 20;
    const container = ref(null);

    const isDown = ref(false);
    const startX = ref(0);
    const scrollLeft = ref(0);

    const getWalkDistance = (currentX) => {
      const x = currentX - container.value.offsetLeft;
      return x - startX.value;
    };

    const mouseDown = (e) => {
      isDown.value = true;
      startX.value = e.pageX - container.value.offsetLeft;
      scrollLeft.value = container.value.scrollLeft;
    };
    const mouseLeave = () => {
      isDown.value = false;
    };
    const mouseUp = (e) => {
      if(!isDown.value) return;
      isDown.value = false;
        if (Math.abs(getWalkDistance(e.pageX)) > CLICK_PREVENT_THRESHOLD) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
    };
    const mouseMove = (e) => {
      if (!isDown.value) return;
      e.preventDefault();
      const walk = getWalkDistance(e.pageX);
      container.value.scrollLeft = scrollLeft.value - walk;
    };

    useEventListener('mousedown', mouseDown, { targetRef: container });
    useEventListener('mouseleave', mouseLeave, { targetRef: container });
    useEventListener('click', mouseUp, { targetRef: container, useCapture: true });
    useEventListener('mousemove', mouseMove, { targetRef: container });

    return { isDown, container };
  },
};
</script>
<style lang="postcss">
.drag-scroll {
  &.snap {
    scroll-snap-type: x mandatory;
    &.scrolling {
      scroll-snap-type: none !important;
    }
  }

  &.scroll-min {
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: var(--grey-ultra-light);
    }
  }
  &.scroll-none {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
